// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.faux-cell[data-v-5a53e99a]\n{\n  background: rgba(0,0,0,.12); \n  height: 2em;\n  margin: 0.1em;\n}\n", ""]);
// Exports
module.exports = exports;
